export const RELEASE_SEGMENTS = ['S1', 'S2', 'S3', 'S4', 'S5']

export const RELEASE_PRIORITIES = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical',
}

export const RELEASE_SCOPES = {
  CONTROL: 'control',
  PARTNER: 'partner',
  BOTH: 'both',
}

export const INTERRUPTIVE_SHOW_COOLDOWN_MS = 24 * 60 * 60 * 1000
export const HIGH_PRIORITY_RETRY_MS = 72 * 60 * 60 * 1000
